var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal",staticStyle:{"margin":"10rem"}},_vm._l((_vm.notes),function(note,index){return _c('div',{key:index,staticClass:"music-note",class:{ 'jump': note.isPlaying }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }